export const updateTripInList = (state, newTrip) => {
  return [...state.trips].map((trip) => {
    if (trip.id === newTrip.id) {
      return { ...newTrip };
    } else return trip;
  });
};

export const updateTripActionInList = (state, newTrip, newAction) => {
  return [...state.trips].map((trip) => {
    if (trip.id === newTrip.id) {
      return { ...newTrip };
    } else return trip;
  });
};

